"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _coreDecorators = require("core-decorators");

var _styles = _interopRequireDefault(require("./styles"));

var _GroupItem = require("../GroupItem");

var _class;

var Group = (_class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Group, _React$PureComponent);

  function Group() {
    (0, _classCallCheck2.default)(this, Group);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Group).apply(this, arguments));
  }

  (0, _createClass2.default)(Group, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          group = _this$props.group,
          selectedKeysSet = _this$props.selectedKeysSet;
      return _react.default.createElement("div", {
        className: _styles.default.root(theme)
      }, renderHeader(group.title, this.headerClickHandler), renderItems(group.items, selectedKeysSet, this.itemClickHandler, theme));
    }
  }, {
    key: "itemClickHandler",
    value: function itemClickHandler(key) {
      if (this.props.selectedKeysSet.has(key)) {
        this.props.onRemoveKey(key);
      } else {
        this.props.onSelectKey(key);
      }
    }
  }]);
  return Group;
}(_react.default.PureComponent), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "itemClickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "itemClickHandler"), _class.prototype)), _class);
exports.Group = Group;

function renderHeader(title, clickHandler) {
  return _react.default.createElement("div", {
    className: _styles.default.header,
    role: "presentation",
    onClick: clickHandler
  }, _react.default.createElement("div", {
    className: _styles.default.title
  }, title));
}

function renderItems(items, selectedKeysSet, itemClickHandler, theme) {
  return _react.default.createElement("div", {
    className: _styles.default.items
  }, items.map(function (i) {
    return _react.default.createElement(_GroupItem.GroupItem, {
      key: i.key,
      theme: theme,
      id: i.key,
      title: i.title,
      count: i.count,
      selected: selectedKeysSet.has(i.key),
      onClick: itemClickHandler
    });
  }));
}